import React, { useEffect } from 'react';
import { TrackFilterClick } from '../../../utilities/insights';
import { useSelector } from 'react-redux';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { Button, Select, FormControl } from '@material-ui/core';

const ActionsBar = ({
    siteId,
    authenticated,
    isOwner,
    isContributor,
    filterValue,
    set_filterValue,
    filterOptions,
    set_showLinkRequest,
    set_showAddModal,
    userName,
    email,
}) => {
    // APP INSIGHTS: Track Filter Changes
    useEffect(() => {
        if (filterValue) {
            TrackFilterClick(siteId, filterValue, userName, email);
        }
    }, [filterValue, userName, email, siteId]);
    const isAdmin = useSelector((state) => state.user.admin);

    return (
        <div>
            <div className='actions'>
                <div className='section'>
                    <FormControl className='actions-bar__select'>
                        <Select native value={filterValue} onChange={(e) => set_filterValue(e.target.value)}>
                            <option value=''>All</option>
                            {filterOptions.map((category, key) => {
                                return (
                                    <option key={key} value={category}>
                                        {category}
                                    </option>
                                );
                            })}
                        </Select>
                    </FormControl>
                </div>
                <div className='rightSection'>
                    {authenticated ? (
                        isOwner || isAdmin || isContributor ? (
                            <Button
                                color='primary'
                                size='large'
                                variant='contained'
                                startIcon={<AddCircleOutlineIcon />}
                                className='action-btn'
                                onClick={() => set_showAddModal(true)}
                            >
                                Add Link
                            </Button>
                        ) : (
                            <Button
                                color='primary'
                                size='large'
                                variant='contained'
                                startIcon={<AddCircleOutlineIcon />}
                                onClick={() => set_showLinkRequest(true)}
                            >
                                Request a Link
                            </Button>
                        )
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default ActionsBar;
